/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ConnectorStatusCount
 */
export interface ConnectorStatusCount {
    /**
     * JETCharge: for all device connectors in the system.
     * JemenaProject: For all device connectors in the Jemena project.
     * Else one of DnspAccessTags enums
     * @type {string}
     * @memberof ConnectorStatusCount
     */
    group?: string;
    /**
     * one of SimpleConnectorState enums
     * @type {string}
     * @memberof ConnectorStatusCount
     */
    status?: string;
    /**
     * The count of connectors in this group, with this status
     * @type {number}
     * @memberof ConnectorStatusCount
     */
    count?: number;
}

/**
 * Check if a given object implements the ConnectorStatusCount interface.
 */
export function instanceOfConnectorStatusCount(
    value: object,
): value is ConnectorStatusCount {
    return true;
}

export function ConnectorStatusCountFromJSON(json: any): ConnectorStatusCount {
    return ConnectorStatusCountFromJSONTyped(json, false);
}

export function ConnectorStatusCountFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ConnectorStatusCount {
    if (json == null) {
        return json;
    }
    return {
        group: json["group"] == null ? undefined : json["group"],
        status: json["status"] == null ? undefined : json["status"],
        count: json["count"] == null ? undefined : json["count"],
    };
}

export function ConnectorStatusCountToJSON(
    value?: ConnectorStatusCount | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        group: value["group"],
        status: value["status"],
        count: value["count"],
    };
}
